import React from 'react';
import { Modal, Button, Row, Col} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faBuilding } from '@fortawesome/free-solid-svg-icons';
import { LinkContainer } from 'react-router-bootstrap'
import { INDIVIDUAL, CORPORATE } from '../../../resources/Utils';

const SimpleModal = (props) => {
    const {show, onClose, state} = props;
    return (
        // <Modal show={show} onHide={onClose} centered size='sm'>
        //     <Modal.Body className="modal-fixed-height p-5">
        //         <p className="text-center font-weight-bold mb-4">Please select customer type</p>
        //         <Button variant="outline-scb" block >Individual Customer</Button>
        //         <p className="text-center my-3">or</p>
        //         <Button variant="outline-scb" block>Corporate Customer</Button>
        //     </Modal.Body>
        // </Modal>
        <Modal show={show} onHide={onClose} centered>
            <Modal.Body className="modal-fixed-height p-5">
                <p className="text-center font-weight-bold mb-4">Please select customer type</p>
                <Row>
                    <Col>
                        <LinkContainer
                            to={{
                            pathname: "/customer/create",
                            state: {...state, type:INDIVIDUAL}
                            }}
                            activeClassName="">
                            <Button variant="outline-scb" block className="p-5">
                                <h1><FontAwesomeIcon size="lg" icon={faUser}/></h1>
                                <p className="mt-2 mb-0">Individual Customer</p>
                            </Button>
                        </LinkContainer>
                    </Col>
                    <Col>
                        <LinkContainer
                            to={{
                            pathname: "/customer/create",
                            state: {...state, type:CORPORATE}
                            }}
                            activeClassName="">
                            <Button variant="outline-scb" block className="p-5">
                                <h1><FontAwesomeIcon size="lg" icon={faBuilding}/></h1>
                                <p className="mt-2 mb-0">Corporate Customer</p>
                            </Button>
                        </LinkContainer>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
}
export default SimpleModal;